/**
 * Module dependencies.
 */

import React from 'react';
import { Card } from '@tremor/react';
import { Title } from 'app/components/atoms/title/title';
import { useTranslation } from 'react-i18next';

/**
 * Export `SettingsOverview` component.
 */

export function SettingsOverview(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <Card>
      <Title>{translate('settings.overview.title')}</Title>
    </Card>
  );
}
